import { ResponsibleGamingOptionType } from "../../../api/common/model/enum/ResponsibleGamingOptionType";
import { Dictionary } from "../../../util/collection/Dictionary";
import { Logger } from "../../../util/log/Logger";
import { GameErrorEvent } from "../../Constants";
import { Dialog } from "../../control/Dialog";
import { TitanButton } from "../../control/TitanButton";
import { TitanPanel } from "../../control/TitanPanel";
import { CommonGameEvent } from "../../controller/event/CommonGameEvent";
import { FactoryManager } from "../../factory/FactoryManager";
import { OrientationType } from "../../renderer/constant/RendererConstants";
import { CommonSnapshot } from "../style/CommonStyle";
import { ResponsibleGamingPanel } from "./ResponsibleGamingPanel";
/**
 * ResponsibleGamingDialog.ts
 */
export class ResponsibleGamingDialog extends Dialog {
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.properties = properties;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerCore(GameErrorEvent.SESSION_TIME_OUT, this.handleSessionTimeout);
    }
    create() {
        super.create();
        this.createBackground();
        this.panel = TitanPanel.createPanel(this, "responsibleGamingPanel", this.properties.panelProperties);
        this.createCancelButton();
        this.createConfirmButton();
        Logger.addObjectRef(this, "ResponsibleGamingDialog");
    }
    createBackground() {
        this.background = this.assetManager.getSprite(this.properties.backgroundProperties);
        this.addChild(this.background);
    }
    createButtons() {
        this.createCancelButton();
        this.createConfirmButton();
    }
    createCancelButton() {
        this.cancelButton = new TitanButton(this.properties.cancelButtonProperties);
        this.cancelButton.name = "cancelButton";
        this.cancelButton.onClick(this.handleCancelButtonSelected, this);
        this.addChild(this.cancelButton);
    }
    createConfirmButton() {
        this.confirmButton = new TitanButton(this.properties.confirmButtonProperties);
        this.confirmButton.name = "confirmButton";
        this.confirmButton.onClick(this.handleConfirmButtonSelected, this);
        this.addChild(this.confirmButton);
    }
    handleConfirmButtonSelected() {
        this.handleConfirm();
    }
    handleConfirm() {
        super.handleConfirm();
        this.dispatchCore(CommonGameEvent.RESPONSIBLE_GAMING_INSTRUCTIONS_CLOSE);
    }
    handleCancelButtonSelected() {
        this.handleCancel();
    }
    update(data) {
        super.update(data);
        this.updateOptions();
    }
    handleAddToScene() {
        const model = FactoryManager.getInstance()?.getFactory()?.getModel();
        if (model) {
            model.dispatchKPI("TITAN_STATE", "PLAY_CONTROLS_OPEN");
        }
    }
    handleRemoveFromScene() {
        const model = FactoryManager.getInstance()?.getFactory()?.getModel();
        if (model) {
            model.dispatchKPI("TITAN_STATE", "PLAY_CONTROLS_SETTINGS_SAVED", model.getResponsibleGaming().getActiveOptionsJSON());
        }
    }
    updateOptions() {
        this.stake = this.data.getParam(ResponsibleGamingDialog.STAKE);
        if (!this.responsibleGaming) {
            this.responsibleGaming = this.data.getParam(ResponsibleGamingDialog.RESPONSIBLE_GAMING);
            this.createOptions();
        }
        this.refreshOptions();
    }
    refreshOptions() {
        for (let type of this.optionPanels.getKeys()) {
            this.refreshOption(type);
        }
    }
    refreshOption(type) {
        let activeOption = this.responsibleGaming.getActiveOption(type);
        let panel = this.optionPanels.getValue(type);
        panel.refresh(this.stake, activeOption);
    }
    createOptions() {
        this.optionPanels = new Dictionary();
        this.createOptionPanel(ResponsibleGamingOptionType.EXTRA_SPIN, this.properties.extraSpinPanelProperties);
        this.createOptionPanel(ResponsibleGamingOptionType.SPIN_PRICE, this.properties.spinPricePanelProperties);
        this.createOptionPanel(ResponsibleGamingOptionType.SINGLE_GAME_STAKE, this.properties.singleGameStakePanelProperties);
        this.createOptionPanel(ResponsibleGamingOptionType.MAXIMUM_LOSS, this.properties.maximumLossPanelProperties);
        this.panel.arrange();
    }
    createOptionPanel(type, properties) {
        let options = this.responsibleGaming.getOptions(type);
        let panel = new ResponsibleGamingPanel(properties);
        panel.onChange(this.handlePanelChange, this);
        panel.update(this.stake, options);
        this.panel.addToPanel(panel, false);
        this.optionPanels.setValue(type, panel);
    }
    handleSessionTimeout() {
        this.confirmButton.setEnabled(false);
    }
    handlePanelChange(button) {
        let data = button.getData();
        this.responsibleGaming.updateOption(data, button.isSelected());
        this.refreshOption(data.getType());
    }
    /* Create Snapshots */
    createSnapshot() {
        let scale = this.scale.clone();
        this.forceRotate(OrientationType.LANDSCAPE);
        this.scale.set(1);
        this.snapshotManager.addPendingTarget(CommonSnapshot.RESPONSIBLE_GAMING, this);
        this.scale.copyFrom(scale);
        this.forceRotate(this.renderer.getOrientation());
    }
}
ResponsibleGamingDialog.RESPONSIBLE_GAMING = "ResponsibleGamingDialog.RESPONSIBLE_GAMING";
ResponsibleGamingDialog.STAKE = "ResponsibleGamingDialog.STAKE";
//# sourceMappingURL=ResponsibleGamingDialog.js.map